import buttonSkin from "./button.skin";

const groupButtonSkin = {
  ...buttonSkin,
  "buttons-group": {
    display: "flex",
  },
};

export default groupButtonSkin;
